// import Cookies from 'js-cookie'; // No longer used

const USER_KEY = 'user';
const SESSION_EXPIRY_KEY = 'session_expiry';
const SESSION_DURATION_DAYS = 7;

// Calculate session expiry date (7 days from now)
const calculateSessionExpiry = () => {
  const expiryDate = new Date();
  expiryDate.setDate(expiryDate.getDate() + SESSION_DURATION_DAYS);
  return expiryDate.getTime();
};

// Check if session is expired
const isSessionExpired = () => {
  try {
    const expiryTimestamp = localStorage.getItem(SESSION_EXPIRY_KEY);
    if (!expiryTimestamp) return true;
    
    const currentTime = new Date().getTime();
    const expiryTime = parseInt(expiryTimestamp);
    
    return currentTime > expiryTime;
  } catch (error) {
    return true;
  }
};

// Remove user data from local storage
const removeUser = () => {
  try {
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(SESSION_EXPIRY_KEY);
  } catch (error) {
  }
};

// User management for localStorage remains
const setUser = (user) => {
  try {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
    localStorage.setItem(SESSION_EXPIRY_KEY, calculateSessionExpiry().toString());
  } catch (error) {
  }
};

const getUser = () => {
  try {
    // Check if session is expired first
    if (isSessionExpired()) {
      removeUser();
      return null;
    }
    
    const user = JSON.parse(localStorage.getItem(USER_KEY));
    return user;
  } catch (error) {
    return null;
  }
};

// Get session expiry date
const getSessionExpiry = () => {
  try {
    const expiryTimestamp = localStorage.getItem(SESSION_EXPIRY_KEY);
    return expiryTimestamp ? new Date(parseInt(expiryTimestamp)) : null;
  } catch (error) {
    return null;
  }
};

// Get remaining session time in milliseconds
const getRemainingSessionTime = () => {
  try {
    const expiryTimestamp = localStorage.getItem(SESSION_EXPIRY_KEY);
    if (!expiryTimestamp) return 0;
    
    const currentTime = new Date().getTime();
    const expiryTime = parseInt(expiryTimestamp);
    
    return Math.max(0, expiryTime - currentTime);
  } catch (error) {
    return 0;
  }
};

// Extend session (useful for "remember me" functionality)
const extendSession = () => {
  try {
    const user = getUser();
    if (user) {
      setUser(user); // This will update the expiry timestamp
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};

// Clear all authentication data
const clearAuth = () => {
  removeUser();
};

// Export the auth utility
const auth = {
  setUser,
  getUser,
  removeUser,
  clearAuth,
  getSessionExpiry,
  getRemainingSessionTime,
  extendSession,
  isSessionExpired,
  SESSION_DURATION_DAYS
};

export default auth;
